export enum HindiLabels {
  About_us = "केवल बारे में",
  Events = "कार्यक्रम",
  Contact_us = "संपर्क करें",
  Social_media = "सोशल मीडिया",
  Facebook = "फेसबुक",
  Instagram = "इंसग्राम",
  Youtube = "यूट्यूब",
  X = "एक्स (ट्विटर)",
  Legal = "कानूनी",
  Join_us = "हमसे जुड़ें",
  Privacy_Policy = "गोपनीयता नीति",
  Matrimony = "शादी",
  Registration_Guidelines = "पंजीकरण दिशानिर्देश",
  Business_Listing = "व्यवसाय सूचियाँ",
  Legal_Documents = "कानूनी दस्तावेजों",
  Quick_Links = "त्वरित सम्पक",
  Mourya_Community_Label = "मौर्य कुशवाहा समाज, ठाणे",
  Mourya_Community_Label2 = "हमारे डिजिटल समुदाय में आपका स्वागत है, जुड़ें और हमें सशक्त बनाएं.",
  Register = "रजिस्टर करें",
  Login = "लॉगिन करें",
  Login_Page = "प्रवेश करें",
  Welcome_Label = "मौर्य कुशवाहा समाज, ठाणे की डिजिटल दुनिया में आपका स्वागत है.",
  Proceed = "जारी रखें",
  Enter_Email = "ईमेल दर्ज करें",
  Dont_Have_Account = "कोई खाता नहीं है ?",
  Already_Have_Account = "क्या आपके पास पहले से एक खाता मौजूद है ?",
  Enter_Full_Name = "अपना पूरा नाम दर्ज करें.",
  Enter_Password = "पास वर्ड दर्ज करें",
  Confirm_Password = "पासवर्ड की पुष्टि कीजिये",
  Enter_DOB = "अपनी जन्मतिथि चुनें.",
  Community_Joining_Que = "समुदाय से जुड़ने में रुचि",
  Edit_Button = "संपादन करना",
  Get_In_Touch_With_Us = "हमारे साथ जुड़े",
  Get_In_Touch_With_Us_Des = "किसी भी पूछताछ या प्रश्न को बेझिझक छोड़ें, हम शीघ्र ही आपसे संपर्क करेंगे",
  Home_Page = "होम",
  Donation = "दान",
  Donate_Page_Header = "आज किसी के जीवन में प्रकाश बनें",
  Donate_Page_Sub_Header = "आशा जगाएं, जीवन बदलें, भविष्य बनाएं",
  Donate_Now = "अभी दान करें",
  Complete_Your_Donation = "अपना दान पूरा करें",
  Enter_Verification_Code = "आपके मोबाइल नंबर पर भेजा गया कोड दर्ज करें",
  Complete_Verification_Step_Info = "*हमारे समुदाय को दान देने के लिए सत्यापन चरण पूरा करें",
  Seconds = "सेकंड",
  Make_Donation_Anonymous = "मेरा दान गुमनाम रखें",
  Donors_Name = "दानकर्ता का नाम",
  Ethnicity = "जातीयता",
  Pan_Number = "पैन नंबर",
  To_Get_Tax_Benefit = "*कर लाभ के लिए 80G प्रमाणपत्र प्राप्त करना आवश्यक है",
  Send_Code = "कोड भेजें",
  Forgot_Password = "पासवर्ड भूल गए?",
  Back_to_Home = "होम",
  Event_Details = "कार्यक्रम विवरण",
  Community_Guidelines = "समुदाय दिशानिर्देश",
  Terms_Conditions = "नियम और शर्तें",
  Matrimony_Guidelines = "विवाह दिशानिर्देश",
  Contact_Requests = "संपर्क अनुरोध",
  Profile_Details = "प्रोफाइल विवरण",
  Approval_Process = "अनुमोदन प्रक्रिया",
  Trouble_Logging_In = "लॉग इन करने में परेशानी?",
  Enter_Email_Address_Description = "अपना ईमेल पता दर्ज करें और हम आपको अपने खाते में वापस आने के लिए एक लिंक भेजेंगे।",
  Get_Reset_Link = "रीसेट लिंक प्राप्त करें",
  Need_Help = "मदद चाहिए?",
  Contact_Support = "सहायता से संपर्क करें",
  Back_To_Login = "लॉगिन पर वापस जाएं",
  Reset_Link_Sent = "रीसेट लिंक आपके ईमेल पर भेज दिया गया है।",
  Failed_To_Send_Reset_Link = "रीसेट लिंक भेजने में विफल। कृपया पुन: प्रयास करें।",
  ENTER_TEMP_PASSWORD = "अस्थायी पासवर्ड दर्ज करें",
  ENTER_NEW_PASSWORD = "नया पासवर्ड दर्ज करें",
  CONFIRM_NEW_PASSWORD = "नए पासवर्ड की पुष्टि करें",
  VERIFY_EMAIL = "ईमेल सत्यापित करें",
  RESET_PASSWORD = "पासवर्ड रीसेट करें",
  RESET_PASSWORD_SUCCESS = "पासवर्ड सफलतापूर्वक रीसेट किया गया। कृपया लॉगिन करें।",
  FAILED_TO_RESET_PASSWORD = "पासवर्ड रीसेट करने में विफल। कृपया पुन: प्रयास करें।",
  TEMP_PASSWORD_MESSAGE = "कृपया अपना अस्थायी पासवर्ड देखने के लिए अपना ईमेल जांचें।",
  No_received_requests = "कोई प्राप्त अनुरोध नहीं।",
  Decline_Request_Confirmation = "अनुरोध अस्वीकार करने की पुष्टि",
  Decline_Request_Confirmation_Desc =
    "क्या आप सुनिश्चित हैं? यह अनुरोध आपकी सूची से हटा दिया जाएगा। गोपनीयता बनाए रखने के लिए प्रेषक को इस कार्रवाई की अलग से सूचना नहीं दी जाएगी।",
  Yes_Decline = "हाँ, अस्वीकार करें",
  Keep_for_now = "अभी के लिए रखें",
  Connection_Successful = "कनेक्शन सफल हुआ!",
  Unable_to_accept_request = "अनुरोध स्वीकार नहीं हो सका।",
  Unable_to_decline_request = "अनुरोध अस्वीकार नहीं हो सका।",
}

export enum Community_Joining_Que_Labels_Hindi {
  Marraige_Purpose = "शादी के लिए",
  Buisness_Purpose = "व्यापार से संबंधित",
  Community_Purpose = "संस्था में शामिल होने के लिए",
  JOb_Purpose = "नौकरी खोजने के लिए",
}

export enum Regisration_Form_Labels_Hindi {
  BIRTH_DATE = "जन्मतिथि",
  GENDER = "लिंग",
  FATHERS_NAME = "पिता का नाम",
  MOTHERS_NAME = "मां का नाम",
  MARITAL_STATUS = "वैवाहिक स्थिति",
  FULL_NAME = "पूरा नाम",
  AADHAR_CARD_NUMBER = "आधार कार्ड नंबर",
  AUTOFILL_ADDRESS = "अपना वर्तमान पता स्वतः भरकर समय बचाएं",
  MOBILE_NUMBER = "दूरध्वनी क्रमांक",
  ALTERNATE_MOBILE_NUMBER = "वैकल्पिक दूरध्वनी क्रमांक",
  EMAIL_ID = "ईमेल आईडी",
  ALTERNATE_EMAIL_ID = "वैकल्पिक ईमेल आईडी",
  ADDRESS_LINE1 = "स्थानीय पत्ता",
  ADDRESS_LINE2 = "स्थायी पत्ता",
  PIN_CODE = "पिनकोड",
  STATE = "राज्य",
  COUNTRY = "देश",
  LAST_NAME = "उपनाम",
  EDUCATIONAL_QUALIFICATION = "शैक्षणिक योग्यता",
  OCCUPATION = "व्यवसाय",
  EMPLOYER_NAME = "नियोक्ता का नाम",
  COMPANY_SIZE = "संग का आकार",
  BUSINESS_DETAILS = "व्यवसाय विवरण",
  POLICY = "मैं संगठन की सभी गोपनीयता नीति से सहमत हूं",
  GO_BACK = "पीछे जाये",
  PROCEED = "आगे बढे",
  SUBMIT = "जमा करे",
  SAVE = "सुरक्षित करे",
  ORGANIZATION = "संगठन",
  MANDATORY = "अनिवार्य हैं"
}

export enum Stepper_labels_Hindi {
  PERSONAL_DETAILS = "व्यक्तिगत विवरण",
  COMMUNICATION_DETAILS = "संचार विवरण",
  CONFIRMATION = "पुष्टीकरण",
  BIO = "परिचय",
}

export enum Admin_Labels_Hindi {
  PENDING_APPROVAL_REQUESTS = "लंबित अनुमोदन अनुरोध",
  APPROVE_ALL = "सभी को स्वीकृत करें",
  REJECT_ALL = "सभी अस्वीकार करें",
  APPROVE = "मंज़ूरी देना",
  REJECT = "अस्वीकार करना",
  NAME = "नाम",
  REASON_FOR_JOINING = "शामिल होने का कारण",
  MOBILE_NO = "मोबाइल नंबर",
  DOB = "जन्म तिथि",
  ACTION = "कार्रवाई",
  ADMIN_DASHBOARD = "व्यवस्थापक डैशबोर्ड",
  TOTAL_REGISTERED_USERS = "कुल पंजीकृत उपयोगकर्ता",
  PENDING_APPROVALS = "लंबित अनुमोदन",
  ACCEPTED_USERS = "स्वीकृत उपयोगकर्ता",
  REJECTED_USERS ="अस्वीकृत उपयोगकर्ता",
  ADMIN_INFO = "व्यवस्थापक जानकारी",
  ADMIN = "व्यवस्थापक",
  MATRIMONY_PROFILES = "वैवाहिक प्रोफाइल",
  MARRIAGE_CONSULTANTS = "विवाह सलाहकार",
  ADMIN_EMAIL = "व्यवस्थापक ईमेल",
  ADMIN_MANAGEMENT="व्यवस्थापक जोड़ें",
  EMAIL = "ईमेल",
  ROLE = "भूमिका",
  STATUS = "स्थिति",
  BLOCKED = "अवरुद्ध",
  No_User_Approval_Pending = "कोई उपयोगकर्ता अनुमोदन लंबित नहीं है",
  NO_HISTORY_FOUND = "कोई इतिहास उपलब्ध नहीं है",
  REASON = "कारण",
  TIMESTAMP = "समयांक",
  ALL = "सभी",
  Approval_Status_Distribution="अनुमोदन स्थिति वितरण",
  User_Approval_History="उपयोगकर्ता अनुमोदन इतिहास"

}

export enum Profile_Tab_Hin {
  FAMILY = "परिवार",
  COMMUNICATION_DETAILS = "संचार विवरण",
  ABOUT = "के बारे में",
  ADDRESS = "पता",
  PROFESSIONAL_BACKGROUND = "व्यावसायिक पृष्ठभूमि",
  MARRIAGE_REGISTRATION = "विवाह पंजीकरण"
}

export enum Abot_Headings_Hin {
  BIO = "परिचय",
  DOB = "जन्म तिथि",
  AGE = "आयु",
  GENDER = "लिंग",
  MARITIAL_STATUS = "वैवाहिक स्थिति",
  ADDHAR_NO = "आधार नं.",
}

export enum Address_Heading_Hin {
  CURRENT_ADDRESS = "वर्त्तमान पता",
  PERMENANT_ADDRESS = "स्थायी पता",
}

export enum Communication_Heading_Hin {
  MOBILE_NUMBER = "संपर्क नंबर",
  ALTERNATE_MOBILE_NUMBER = "वैकल्पिक संपर्क नं.",
  EMAIL_ID = "ईमेल आईडी",
  ALTERNATE_EMAIL_ID = "वैकल्पिक ईमेल आईडी",
}

export enum PROFILE_HEADINGS_HIN {
  ORGANIZATION = "संगठन",
  UNIVERSITY = "विश्वविद्यालय",
  GRADUATION_YEAR = "स्नातक वर्ष",
  AGE = "आयु",
  CURRENT_ADDRESS = "वर्त्तमान पता",
  PERMENANT_ADDRESS = "स्थायी पता",
  ADD_FAMILY_MEMBER = "परिवार के सदस्य जोड़ें",
  BIO = "जीवन वृत्त",
  OCCUPATION = "व्यवसाय",
  BUSINESS_DETAILS = "व्यवसाय विवरण",
  EDUCATIONAL_QUALIFICATION = "शैक्षणिक योग्यता"
}

export enum LANDING_PAGE_LABELS_HIN {
  CELEBRATING_UNITY_AND_TRADITION = "एकता और परंपरा का जश्न",
  ABOUT_OUR_COMMUNITY = "हमारी समुदाय के बारे में",
  A_VAST_COMMUNITY_OF = "एक विशाल समुदाय का",
  SANSTHAS = "संस्थाएँ",
  LIFETIME_MEMBERS = "आजीवन सदस्य",
  GENERAL_MEMBERS = "सामान्य सदस्य",
  EVENTS = "आयोजन",
}

export enum ABOUT_US_HIN {
  ABOUT_OUR_COMMUNITY_1 = "मौर्य कुशवाहा समाज, ठाणे, की स्थापना 14 फरवरी 1993 को हुई थी, और यह 14 फरवरी 1994 को आधिकारिक रूप से पंजीकृत हुआ। यह संगठन ठाणे, मौर्य और कुशवाहा समुदायों के सदस्यों के बीच एकता और भाईचारे को बढ़ावा देने के लिए समर्पित है। हमारा उद्देश्य सांस्कृतिक विरासत को संरक्षित करना, सामाजिक विकास को प्रोत्साहित करना, और विभिन्न पहलों और कार्यक्रमों के माध्यम से व्यक्तियों को सशक्त बनाना है।",
  ABOUT_OUR_COMMUNITY_2 = "हम सम्मेलनों, व्यावसायिक सम्मेलनों, और सांस्कृतिक कार्यक्रमों का आयोजन करते हैं, जो नेटवर्किंग, ज्ञान साझा करने, और समुदाय की प्रगति के लिए मंच प्रदान करते हैं। हमारी सोशल मीडिया पर सक्रिय उपस्थिति हमें सदस्यों से जुड़ने, अपडेट साझा करने, और सार्थक चर्चाओं में भाग लेने में सक्षम बनाती है।",
  ABOUT_OUR_COMMUNITY_3 = "हमारे प्रयासों के माध्यम से, हम एक समेकित और सहायक वातावरण बनाने का लक्ष्य रखते हैं, जो व्यक्तिगत और व्यावसायिक विकास को प्रोत्साहित करता है, साथ ही मौर्य और कुशवाहा समुदायों की समृद्ध परंपराओं को संरक्षित करता है।",
}

export enum EVENTS_HIN {
  UPCOMING_EVENTS = "आगामी कार्यक्रम",
  RECENT_EVENTS = "हाल की कार्यक्रम",
}

export enum BUTTONS_HIN {
  VIEW_ALL = "सभी को देखें",
  EDIT = "संपादित करें",
  NEXT = "अगला",
  PREV = "पिछला",
}
 export enum STATUS_LABELS_HIN {
  APPROVED = "स्वीकृत",
  PENDING = "लंबित",
  REJECTED = "अस्वीकृत",
}
